import { render, staticRenderFns } from "./GridOfferRowRedesignExp.vue?vue&type=template&id=2123a350&scoped=true"
import script from "./GridOfferRowRedesignExp.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridOfferRowRedesignExp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GridOfferRowRedesignExp.vue?vue&type=style&index=0&id=2123a350&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2123a350",
  null
  
)

export default component.exports